module.exports = __webpack_public_path__ + "static/media/profile-icon.cfb3a4d4.svg";